module.exports = __webpack_public_path__ + "img/num_layout_04.63cac16d.png";